import { usePermissions } from 'react-admin';

import { MongoAbility } from '@casl/ability';

/**
 * Hook to return the CASL ability of a user,
 * so that we can control access to things
 * Example usage:
 * const ability = useAbility();
 * if (ability.can(CASLAction.WRITE, "users"));
 * @returns
 */
export const useAbility = () => {
  const { permissions } = usePermissions();
  /**
    Using a type-guard here, because otherwise we'd have to
    continuous check that whatever is returned by this hook is not null
    e.g.:
      const ability = useAbility();
      if (ability && ability.can(...)

   With the type-guard, we don't need the if(ability) check
   */
  return (
    (permissions as MongoAbility) ?? {
      can: () => false,
      cannot: () => true,
    }
  );
};

export enum CASLAction {
  GET = 'get',
  WRITE = 'write',
  DELETE = 'delete',
  REORDER = 'reorder',
  MANAGE = 'all',
}
